export class Proceed {
  constructor(
    private _labProceed: number = null,
    private _geniusProceed: number = null,
    private _dealerProceed: number = null,
    private _agentProceed: number = null,
    private _mshpProceed: number = null
  ) { }

  get labProceed(): number {
    return this._labProceed;
  }

  get geniusProceed(): number {
    return this._geniusProceed;
  }

  get dealerProceed(): number {
    return this._dealerProceed;
  }

  get agentProceed(): number {
    return this._agentProceed;
  }

  get mshpProceed(): number {
    return this._mshpProceed;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/model/proceed.ts